
import React, { Component } from 'react';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class SliderComponent extends Component 
{

    render()
    {
        var min = this.props.min * 1;
        var max = this.props.max * 1;
        var value = this.props.getValue() * 1;

        var caption = this.props.getCaption();
        if (!this.props.usePlainCaption)
            caption = `${caption} - ${value}`;

        var step = 1;
        if (this.props.step)
            step = this.props.step;

        return <div>
                    <div>{caption}</div>
                    <div className='slider' style={{marginTop:'-5px'}}>
                        <Slider
                            min={min}
                            max={max}
                            value={value}
                            tooltip={false}
                            step={step}
                            onChange={(value)=>
                            {
                                this.props.setValue(value * 1);
                            }}
                        />
                    </div>
                    <div className='hint-text' style={{marginLeft:'5px', marginTop:'-5px'}}>{this.props.getHints()}</div>
                </div>
    }
}

export default SliderComponent;